import { PAY_TYPE_TOKEN, PayType } from '~/api/jobs'
import { lazyMsg } from '~/common/localizationUtils'

export const SOW_WORKERS_PER_PAGE = 10

export const TEAM_HOME_PATH = '/team'
export const TEAM_WORKERS_PATH = '/team/workers'
export const TEAM_WORKERS_CHECKLISTS_PATH = '/team/workers/:candidateId/job/:jobId'

export const TEAM_HOME_DEFAULT_STATUS_FILTERS = '?status=1%2C4'
export const TEAM_WORKERS_DEFAULT_STATUS_FILTERS = '?status=7%2C8%2C25%2C29%2C6%2C23'
export const TEAM_WORKERS_CHECKLISTS_DEFAULT_STATUS_FILTERS = '?search=&status=1%2C2%2C3%2C4%2C5%2Cexpire_soon'

export const getSharedFilters = (sowId: number, sowVersionId: number) => [
  {
    id: 'job_template',
    title: lazyMsg('term.role'),
    type: 'select',
    listType: 'number',
    defaultIsOpen: true,
    config: { containerMaxHeight: 600 },
    optionsFromApi: {
      preload: true,
      pageSize: 100,
      searchParamKey: 'title',
      url: `/api/v2/sow-module/sow/${sowId}/version/${sowVersionId}/job-templates/`,
      queries: ['title={{value}}'],
      transform: '[$.results.{"value": id, "label": title, "id": id.$string()}]'
    }
  }
]

/**
 * Pay type filter for the Teams tab. Returns nothing when the tenant has only one pay type enabled.
 */
export const getPayTypeFilter = (enabledPayTypes: PayType[]) => {
  if (enabledPayTypes.length < 2) return []

  return [
    {
      id: 'contract_pay_type',
      title: lazyMsg('term.pay_type', { count: 1 }),
      type: 'list',
      options: enabledPayTypes.map(payType => ({ text: PAY_TYPE_TOKEN[payType], value: String(payType) })),
      defaultIsOpen: true
    }
  ]
}

export const getJobDetailsOrDraftHref = (sowId: number, versionId: number, jobId: number): string => {
  return `/sow/${sowId}/team/jobs/${jobId}/details?versionId=${versionId}`
}
